import { Panel_Header_default } from "./chunk-KAV3A64U.js";
import { Panel_default } from "./chunk-6PD57CJN.js";

// src/elements/Panel/index.ts
var PanelComponent = Panel_default;
PanelComponent.Header = Panel_Header_default;
PanelComponent.Header.displayName = "Panel.Header";
export { PanelComponent };